module.exports = __webpack_public_path__ + "media/categories-photos/25-4737ad4a.webp";